import React, { useEffect, useState } from "react";
import { Spin, Empty, message } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./MyOrders.css";

const Stat = ({ label, value }) => (
  <div>
    <span className="order-stat__label">{label}</span>
    <span className="order-stat__value">{value}</span>
  </div>
);

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkUserActiveStatus();
    fetchOrders();
    // eslint-disable-next-line
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          // Redirect to home if AllowtoOrder is false
          if (response.data.AllowtoOrder === false) {
            window.location.href = "/";
            return;
          }

          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === true
          ) {
            alert("Your session has expired. Please log in again.");

            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.reload();
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/Order/GetOrderList",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      setOrders(response.data || []);
    } catch (error) {
      message.error("Failed to fetch orders.");
      setOrders([]);
    }
    setLoading(false);
  };

  // Helper for Indian number format with 2 decimals
  const formatINR = (value) =>
    value !== undefined && value !== null
      ? value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00";

  // Helper for date format "dd-MM-yyyy"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const openOrder = (orderId) => navigate(`/orderdetail/${orderId}`);

  return (
    <div className="orders-page">
      <div className="orders-header">
        <h1>My Orders</h1>
        {!loading && orders.length > 0 && (
          <p>
            {orders.length} order{orders.length !== 1 ? "s" : ""} placed
          </p>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 72 }}>
          <Spin size="large" />
        </div>
      ) : orders.length === 0 ? (
        <Empty
          description="No orders found"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: "64px 0" }}
        />
      ) : (
        <div className="orders-list">
          {orders.map((record) => (
            <div
              className="order-card"
              key={record.OrderID}
              role="button"
              tabIndex={0}
              onClick={() => openOrder(record.OrderID)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  openOrder(record.OrderID);
                }
              }}
            >
              <div className="order-card__top">
                <div style={{ minWidth: 0 }}>
                  <div className="order-card__id">Order #{record.OrderID}</div>
                  <div className="order-card__date">
                    <CalendarOutlined />
                    {formatDate(record.OrderDate)}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div className="order-card__total-label">Grand Total</div>
                  <div className="order-card__total">
                    ₹{formatINR(record.GrandTotal)}
                  </div>
                </div>
              </div>

              <div className="order-card__rule" />

              <div className="order-card__stats">
                <Stat label="Boxes" value={formatINR(record.TotalBox)} />
                <Stat
                  label="Quantity"
                  value={formatINR(record.TotalQuantity)}
                />
                <Stat
                  label="Sub Total"
                  value={`₹${formatINR(record.SubAmount)}`}
                />
                <Stat label="GST" value={`₹${formatINR(record.GSTAmount)}`} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyOrders;
